<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>
              <router-link class="btn btn-sm" :to="{ name: 'OpenVPNServerList' }">
                <i class="fas fa-chevron-left"></i>
              </router-link>
              Open VPN Server
            </h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Open VPN Server</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card" id="OpenVPNServer">
          <div class="overlay" v-if="is_loading">
            <img src="/assets/images/loader.svg" alt="" />
          </div>
          <form @submit.prevent="handleSubmission()" method="POST" novalidate>
            <div class="card-header py-3">
              <h3 class="card-title" v-if="!is_edit">Create</h3>
              <h3 class="card-title" v-if="is_edit">Edit</h3>
            </div>
            <div class="card-body pb-1">
              <div class="row">
                <div class="col-md-8">
                  <div v-if="organizationId == 1" class="form-group required">
                    <label class="control-label">Audra</label>
                    <input
                      v-if="is_edit"
                      type="text"
                      v-model="pre.audraName[value.accountId]"
                      id="accountId"
                      class="form-control accountId"
                      name="accountId"
                      readonly
                    />
                    <multiselect
                      v-else
                      v-model="value.accountId"
                      :options="Object.keys(pre.audraName)"
                      :custom-label="(opt) => pre.audraName[opt]"
                      placeholder="Select Audra Name"
                      :searchable="true"
                      :multiple="false"
                      id="accountId"
                      v-bind:class="{ 'has-error': errors.has('accountId') }"
                      v-validate="'required'"
                      name="accountId"
                    >
                    </multiselect>
                    <div class="help text-danger" v-show="errors.has('accountId')">
                      {{ errors.first("accountId") }}
                    </div>
                  </div>

                  <div class="form-group required">
                    <label class="control-label">Type</label>
                    <div class="d-flex align-items-center">
                      <label class="radio mr-3">
                        <input
                          type="radio"
                          id="vpn_type"
                          name="vpn_type"
                          v-model="value.vpn_type"
                          class=""
                          value="0"
                          v-bind:class="{
                            'has-error': errors.has('vpn_type'),
                          }"
                          v-validate="'required'"
                        />
                        <span class="radio-mark"></span>
                        User password
                      </label>
                      <label class="radio">
                        <input
                          type="radio"
                          id="vpn_type"
                          name="vpn_type"
                          v-model="value.vpn_type"
                          class=""
                          value="1"
                          v-bind:class="{
                            'has-error': errors.has('vpn_type'),
                          }"
                          v-validate="'required'"
                        />
                        <span class="radio-mark"></span>
                        Certificate
                      </label>
                    </div>

                    <div class="help text-danger" v-show="errors.has('vpn_type')">
                      {{ errors.first("vpn_type") }}
                    </div>
                  </div>

                  <div class="form-group required">
                    <label class="control-label">Name</label>
                    <input
                      :disabled="is_edit"
                      type="text"
                      id="vpn_server_name"
                      name="vpn server name"
                      v-model="value.vpn_server_name"
                      v-validate="'required|alpha_num|max:50|min:5'"
                      class="form-control vpn_server_name"
                      placeholder="Input Server Name. Example : OpenVPNServer"
                    />
                    <div class="help text-danger" v-show="errors.has('vpn server name')">
                      {{ errors.first("vpn server name") }}
                    </div>
                  </div>

                  <div class="form-group required">
                    <label class="control-label">Pool</label>
                    <input
                      type="text"
                      id="vpn_pool"
                      name="vpn_pool"
                      v-model="value.vpn_pool"
                      v-validate.lazy="'required|ip_CIDR'"
                      class="form-control vpn_pool"
                      placeholder="Input VPN Network. Example : 10.10.10.0/24"
                    />
                    <div class="help text-danger" v-show="errors.has('vpn_pool')">
                      {{ `The VPN Network required in proper network address format.` }}
                    </div>
                  </div>

                  <div class="form-group required">
                    <label class="control-label">Server</label>
                    <input
                      type="text"
                      id="vpn_server"
                      name="vpn_server"
                      v-model="value.vpn_server"
                      v-validate="'required'"
                      class="form-control vpn_server"
                      placeholder="Input Server IP/Domain. Example: 192.168.20.1 or www.audra.io"
                      pattern="^(([0-9]{1,3}\.){3}[0-9]{1,3})|([a-zA-Z0-9-]+\.){1,}[a-zA-Z]{2,}$"
                    />

                    <div class="help text-danger" v-show="errors.has('vpn_server')">
                      {{
                        `The VPN Server must be in a proper IP or Domain address format.`
                      }}
                    </div>
                  </div>

                  <div class="form-group required">
                    <label class="control-label">Port</label>
                    <input
                      type="text"
                      id="vpn_port"
                      name="vpn_port"
                      v-model="value.vpn_port"
                      v-validate="'required'"
                      class="form-control vpn_port"
                      placeholder="Input VPN Port. Example: 1194"
                      pattern="^([1-9][0-9]{0,3}|[1-5][0-9]{4}|6[0-4][0-9]{3}|65[0-4][0-9]{2}|655[0-2][0-9]|6553[0-5])$"
                    />
                    <div class="help text-danger" v-show="errors.has('vpn_port')">
                      {{
                        `The VPN Port must be a valid port number between 1 and 65535.`
                      }}
                    </div>
                  </div>

                  <div class="form-group required" v-if="value.vpn_type == 0">
                    <label class="control-label">Split Tunnel</label>
                    <div class="d-flex align-items-center">
                      <label class="radio mr-3">
                        <input
                          type="radio"
                          id="split_tunnel"
                          name="split tunnel"
                          v-model="value.split_tunnel"
                          class=""
                          value="1"
                          v-bind:class="{
                            'has-error': errors.has('type'),
                          }"
                          v-validate="'required'"
                        />
                        <span class="radio-mark"></span>
                        Yes
                      </label>
                      <label class="radio">
                        <input
                          type="radio"
                          id="split_tunnel"
                          name="split tunnel"
                          v-model="value.split_tunnel"
                          class=""
                          value="0"
                          v-bind:class="{
                            'has-error': errors.has('split_tunnel'),
                          }"
                          v-validate="'required'"
                        />
                        <span class="radio-mark"></span>
                        No
                      </label>
                    </div>

                    <div class="help text-danger" v-show="errors.has('split tunnel')">
                      {{ errors.first("split tunnel") }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer pt-0 pb-4">
              <button type="submit" v-if="!is_edit" class="btn">Submit</button>
              <button type="submit" v-if="is_edit" class="btn">Update</button>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// import MasterLayout from "@/components/layouts/MasterLayoutComponent";
import { CommonAPI } from "@/services/api";
import LocalStorage from "@/services/localStorage";
import axios from "axios";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

export default {
  name: "OpenVPNServerForm",
  metaInfo: {
    title: "Open VPN Server | Dotlines",
  },
  components: {
    DatePicker,
  },
  data: () => ({
    organizationId: LocalStorage.get("organizationId"),
    userEmail: LocalStorage.get("userEmail"),
    isSelectorLoading: false,
    is_loading: false,
    is_edit: false,
    params: {},
    split_tunnel: 1,
    value: {},
    pre: {
      audraName: {},
    },
  }),
  methods: {
    handleSubmission() {
      const _this = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          _this.is_loading = true;
          let api_url = "/open_vpn_servers";
          let method = "POST";
          if (_this.is_edit) {
            api_url = "/open_vpn_servers/" + _this.$route.params.id;
            method = "PUT";
          }

          axios({
            method: method,
            url: api_url,
            data: _this.value,
            headers: { "Content-Type": "application/json" },
          })
            .then(function (response) {
              _this.$toaster.success(response.data.message);
              _this.$router.push({ name: "OpenVPNServerList" });
            })
            .catch((errors) => {
              if (errors.response.status === 501) {
                _this.$toaster.error(errors.response.data.errors.message);
                _this.$setErrorsFromResponse(errors.response.data.errors);
              } else if (errors.response.status === 422) {
                if (
                  errors.response.data.errors &&
                  errors.response.data.errors.vpn_server_name
                ) {
                  // Display the specific error message for vpn_server_name
                  _this.$toaster.error(
                    errors.response.data.errors.vpn_server_name.join(", ")
                  );
                } else {
                  // Fallback if there's no specific vpn_server_name error
                  _this.$toaster.error(errors.response.data.errors.message);
                }
                _this.$setErrorsFromResponse(errors.response.data.errors);
              } else if (errors.response.data) {
                _this.$toaster.error(errors.response.data.message);
                _this.$setErrorsFromResponse(errors.response.data);
              }
            })

            .finally(() => {
              _this.is_loading = false;
            });
        }
      });
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        const api_url = "/open_vpn_servers/" + id;
        axios
          .get(api_url, {
            params: { accountId: LocalStorage.get("accountId") },
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            // console.log("error " + error);
            reject(error);
          });
      });
    },
    async initialize() {
      this.is_loading = true;
      this.params = this.$route.params;

      if (!_.isEmpty(this.params) && this.params.id !== undefined) {
        this.is_edit = true;
      }
      if (this.is_edit) {
        await this.getDetail(this.params.id)
          .then((response) => {
            this.value = response.data;
          })
          .catch((errors) => {
            if (errors.response.status === 501) {
              this.$toaster.error(errors.response.data.errors.message);
              this.$setErrorsFromResponse(errors.response.data.errors);
            } else if (errors.response.data) {
              this.$toaster.error(errors.response.data.message);
              this.$setErrorsFromResponse(errors.response.data);
            }
            this.$router.back();
          });
      } else {
        this.value.accountId = LocalStorage.get("accountId");
        this.value.vpn_type = 0;
      }

      await CommonAPI.getAudraName(LocalStorage.get("accountId"))
        .then((response) => {
          this.pre.audraName = response;
        })
        .catch((error) => {
          console.log(error.response);
        });
      this.setCustomValidation();
      this.is_loading = false;
    },
    setCustomValidation: function () {
      this.$validator.extend("ip_CIDR", {
        getMessage: (field) =>
          "The input format is invalid. Valid Format : 192.168.20.0/24",
        validate: (value) => {
          return this.validateIpCidr(value) ? 1 : 0;
        },
      });
    },
    validateIpCidr(value) {
      const ipAddressPattern = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\/(3[0-2]|[0-2]?[0-9])$/;
      return ipAddressPattern.test(value) ? 1 : 0;
    },
  },
  mounted() {
    this.initialize();
  },
};
</script>
